import { useState, useEffect, useCallback } from 'react';

export const useCommentInlineLinkingStreaming = (streamingInterval = 50, batchSize = 3) => {
	const [buffer, setBuffer] = useState<string[]>([]);
	const [inlineLinkingContent, setInlineLinkingContent] = useState<string>('');
	const [lastProcessedLength, setLastProcessedLength] = useState<number>(0);
	const [isBufferStreaming, setIsBufferStreaming] = useState<boolean>(false);

	const updateBuffer = useCallback((newContent: string) => {
		setIsBufferStreaming(true);
		setBuffer((prev) => [...prev, ...newContent.split('')]);
	}, []);

	const resetStreaming = useCallback(() => {
		setBuffer([]);
		setInlineLinkingContent('');
		setLastProcessedLength(0);
		setIsBufferStreaming(false);
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
			setBuffer((prevBuffer) => {
				if (prevBuffer.length > 0) {
					const contentToProcess = prevBuffer.slice(0, batchSize).join('');
					let updatedBatchSize = batchSize;
					if (contentToProcess.includes('<')) {
						// Stream complete HTML tags as a unit
						for (let i = 0; i < prevBuffer.length; i++) {
							if (prevBuffer[i] === '>') {
								// Include the > character
								updatedBatchSize = i + 1;
								break;
							}
						}
					}
					setInlineLinkingContent(
						(prevContent) => prevContent + prevBuffer.slice(0, updatedBatchSize).join(''),
					);
					return prevBuffer.slice(updatedBatchSize);
				}

				if (isBufferStreaming) {
					setIsBufferStreaming(false);
				}

				return prevBuffer;
			});
		}, streamingInterval);
		return () => clearInterval(interval);
	}, [batchSize, streamingInterval, isBufferStreaming]);

	return {
		inlineLinkingContent,
		buffer,
		updateBuffer,
		lastProcessedLength,
		setLastProcessedLength,
		isBufferStreaming,
		resetStreaming,
	};
};
